import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@nubank/nuds-web/components/Box/Box';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import styled from 'styled-components';
import Image from '@nubank/nuds-web/components/Image/Image';
import Link from '@nubank/nuds-web/components/Link/Link';
import { createPortal } from 'react-dom';

import PartnerModal from './PartnerModal';

const StyledBox = styled(Box)`
  :last-child, :nth-child(4), :nth-child(8) {
    margin-right: 0; /* Exclude margin from the last grid item */
  }

  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  cursor: pointer;

  :hover {
    transform: scale(1.05);
    box-shadow: 0 8px 16px rgb(0 0 0 / 10%);
  }

  @media (768px <= width <= 1024px) {
    flex-basis: 100%;
    width: 90%;
    margin-right: 0;
    margin-top: 20px;
  }
`;

const StyledImage = styled(Image)`
  margin: 0 auto;
`;

const PartnersContainer = styled(Box)`
  @media (768px <= width <= 1024px) {
    flex-direction: column;
    align-items: center;
  }
`;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  width: fit-content;
`;

function PartnersGrid({ partnersList }) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemClick = itemId => {
    const selectedPartner = partnersList.find(item => item.id === itemId);
    setSelectedItem(selectedPartner);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  }, [isOpen]);

  return (
    <>
      <PartnersContainer
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        paddingHorizontal="35px"
        maxWidth="1433px"
        margin="0 auto"
        paddingBottom="100px"
      >
        {partnersList.map((partner, index) => (
          <StyledBox
            key={partner.id}
            flexBasis="calc(25% - 35px);"
            marginRight="35px"
            width="300px"
            height="347px"
            marginTop={index > 3 ? '35px' : '0'}
            paddingTop="26px"
            paddingBottom="30px"
            paddingHorizontal="4x"
            borderRadius="12px"
            background="white"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            onClick={() => handleItemClick(partner.id)}
          >

            <StyledImage
              alt={partner.image.alt}
              src={partner.image.url}
              width="133px"
              height="133px"
              loading="lazy"
              objectFit="contain"
              webp
            />

            <Typography
              variant="subtitle1"
              strong
              marginTop="27px"
              marginBottom="35px"
              textAlign="center"
              totalChars={partner.title.length}
              height="72px"
            >
              {partner.title}
            </Typography>

            {/* Link that works as a button ¯\_(ツ)_/¯ */}

            <StyledLink
              href="###"
              alt="Ver beneficio"
              variant="action"
              iconProps={{
                name: 'arrow-right',
              }}
              onClick={e => {
                e.preventDefault();
                handleItemClick(partner.id);
              }}
            >
              Ver beneficio
            </StyledLink>
          </StyledBox>
        ))}
      </PartnersContainer>

      {/* MODAL OVERLAY FOR MORE DETAILS */}

      {isOpen && selectedItem && createPortal(
        <PartnerModal closeModal={closeModal} item={selectedItem} isOpen={isOpen} />, document.getElementById('modal-root'),
      )}
    </>
  );
}

PartnersGrid.propTypes = {
  partnersList: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.string,
      image: PropTypes.shape({
        alt: PropTypes.string,
        url: PropTypes.string,
      }),
      moreLink: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
};

export default PartnersGrid;
